import React from 'react';
import styles from './HtmlContent.module.scss';

export interface HtmlContentProps {
  className?: string;
  content: string;
}

export const HtmlContent = ({
  className = '',
  content
}: HtmlContentProps): React.ReactElement<HtmlContentProps> => {
  return (
    <div
      className={`${styles.htmlContent} ${className}`}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};
